import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { globalFontStyle } from "../../../assets";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import { Network } from "../../../utils/network";

const TopUp = ({ onTopUpResponse, contestId, contestBalanceData }) => {
  let contestJoiningFee = 1;

  const onBtnCLick = async () => {
    const res = await Network.contestTopUp({ contest_id: contestId }, true);
    onTopUpResponse(res);
  };
  return (
    <View
      style={[
        {
          flex: 1,
          justifyContent: "flex-start",
          width: Width.width,
        },
      ]}
    >
      <View style={styles.headerStyle}>
        <Text style={styles.headerText}>Coins you will get</Text>
      </View>
      <View style={{ paddingHorizontal: 18, paddingBottom: 24 }}>
        <View style={styles.middleView}>
          <Text style={styles.amountStyle}>
            {contestBalanceData?.virtual_credits}
          </Text>
        </View>
        <CustomButton
          btnText={"Confirm Top-up"}
          btnType={"btnBlack"}
          onBtnClick={onBtnCLick}
          customStyle={{ flex: 1, paddingVertical: 12 }}
          isSubText={`(${contestBalanceData?.entry_fee} will be deducted from your wallet)`}
        />
      </View>
    </View>
  );
};

export default TopUp;

const styles = StyleSheet.create({
  headerStyle: {
    padding: 18,
    //paddingTop: 2,
    backgroundColor: "#F8F8F8",
    marginTop: -16
  },
  middleView: {
    paddingHorizontal: 18,
    paddingVertical: 40,
    alignItems: "center",
  },
  amountStyle: {
    ...globalFontStyle.appFontTitleHead,
  },
  headerText: {
    ...globalFontStyle.appFontSubHeading,
  },
});
